const renderNumber = (item) => new Intl.NumberFormat('es-ES').format(item);

const renderDate = (item) => {
    const { text } = formatDateWithClass(item);
    return <p className="table-date">{text}</p>;
};

const renderDateWithRed = (item) => {
    const { text, className } = formatDateWithClass(item);
    return <p className={className}>{text}</p>;
};

const renderWithRedIfEmpty = (item) => {
    let className = 'table-date';
    if (!item) className += ' text-red';
    return <p className={className}>{item}</p>;
};

const commonColumns = {
    name: { name: 'NOMBRE', key: 'name_crm', render: (item) => item.toUpperCase() },
    parts: { name: 'PIEZAS', key: 'total', render: renderNumber },
    lastUpdate: {
        name: 'ÚLTIMA ACTUALIZACIÓN',
        key: 'update_time',
        render: renderDateWithRed,
    },
};

export const integracionesKeys = [
    {
        tableName: 'Integraciones',
        partsKey: 'totalIntegrations',
        statusKey: 'importsStatus',
        columnNames: [
            commonColumns.name,
            commonColumns.parts,
            {
                name: 'IMPORTACIÓN',
                key: 'docu',
                render: renderWithRedIfEmpty,
            },
            {
                name: 'FECHA',
                key: 'docu_date',
                render: renderDate,
            },
            {
                name: 'IMAGENES',
                key: 'imagenes',
                render: renderWithRedIfEmpty,
            },
            {
                name: 'FECHA',
                key: 'imagenes_date',
                render: renderDate,
            },
            {
                name: 'PROCESADO',
                key: 'procesado',
            },
            {
                name: 'FECHA',
                key: 'procesado_date',
                render: renderDate,
            },
            {
                name: 'COMENTARIO',
                key: 'comentario',
            },
            {
                name: '% IMGS IMPORT.',
                key: 'images_p',
                render: (item) => {
                    const num = Number(item);
                    if (isNaN(num)) return '-';
                    if (num % 1 === 0) return num.toString();
                    return num.toFixed(2);
                },
            },
            {
                name: 'ÚLTIMA CONEXIÓN',
                key: 'update_time',
                render: renderDateWithRed
            },
        ],
    },
    {
        tableName: 'Desguaces atena',
        partsKey: 'totalAtena',
        statusKey: 'atenaStatus',
        columnNames: [commonColumns.name, commonColumns.parts, commonColumns.lastUpdate],

    },
    {
        tableName: 'Desguaces seinto',
        partsKey: 'totalSeinto',
        statusKey: 'seintoStatus',
        columnNames: [commonColumns.name, commonColumns.parts, commonColumns.lastUpdate],

    },
    {
        tableName: 'Desguaces mb',
        partsKey: 'totalMB',
        statusKey: 'mbStatus',
        columnNames: [commonColumns.name, commonColumns.parts, commonColumns.lastUpdate],

    },
    {
        tableName: 'Desguaces Conmuta',
        partsKey: 'totalConmuta',
        statusKey: 'conmutaStatus',
        columnNames: [commonColumns.name, commonColumns.parts, commonColumns.lastUpdate],
    },
    {
        tableName: 'Desguaces azeler',
        partsKey: 'totalAZ',
        statusKey: 'azStatus',
        columnNames: [commonColumns.name, commonColumns.parts, commonColumns.lastUpdate],

    },
];

const formatDateWithClass = (dateStr) => {
    if (!dateStr) return { text: '-', className: '' };

    const fecha = new Date(String(dateStr));
    if (isNaN(fecha.getTime())) return { text: '-', className: '' };

    // Normalizar horas
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    fecha.setHours(0, 0, 0, 0);

    const day = String(fecha.getDate()).padStart(2, '0');
    const month = String(fecha.getMonth() + 1).padStart(2, '0');

    let className = 'table-date';
    if (fecha < today) className += ' text-red';

    return {
        text: `${day}/${month}`,
        className,
    };
};
